import React from "react";
import { useUseGetCountryListQuery } from "../../store/api/filterApi";
import { useDispatch, useSelector } from "react-redux";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";
import Loader from "../common/Loader";

const Location = () => {
  const { data: locationData, isLoading: locationIsLoading } =
    useUseGetCountryListQuery();

  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "location", value: value }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "location", value: value }));
  };
  return (
    <div className="w-100 mt-3">
      <label className="filter-main-label">Location</label>
      <div className="location-range">
        {locationIsLoading && (
          <div>
            <Loader />
          </div>
        )}
        {locationData?.data?.map((item) => {
          return (
            <div
              className={`range-item`}
              // style={{
              //   width: `calc(100% / ${locationData?.data?.length})`,
              // }}
              onClick={() =>
                filterSelect?.location?.includes(item?.name)
                  ? handleRemoveFilter(item?.name)
                  : handleAddFilter(item?.name)
              }
            >
              <div
                className={` ${
                  filterSelect?.location?.includes(item?.name) ? "active" : ""
                }`}
              >
                {item?.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Location;
